export default __webpack_public_path__ + "static/media/MDnius_QR_Code@2x.565f8cee.png";